import React, { useEffect, useState } from "react";
import { fetchItems, deleteItem } from "../../api/api";
import { Button, Dropdown } from 'react-bootstrap';
import NsnInfo from "./NsnInfo";

const ItemInfo = ({ itemId }) => {
    const [itemData, setItemData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState(null);

    const fetchData = async () => {
        const data = await fetchItems(itemId);
        setItemData(data);
        setLoading(false);
    };

    useEffect(() => {
        if (!itemId) return;
        setLoading(true);
        fetchData();
        // eslint-disable-next-line
    }, [itemId]);

    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete this item? This cannot be undone.")) return;
        setDeleting(true);
        setDeleteError(null);
        try {
            await deleteItem(itemId);
            setItemData(null);
        } catch (err) {
            setDeleteError("Failed to delete item.");
        }
        setDeleting(false);
    };

    if (loading) return <div>Loading...</div>;
    if (!itemData) return <div>Item not found.</div>;

    const { item, nsn_info } = itemData;

    return (
        <div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Button>Edit</Button>
                <Dropdown>
                    <Dropdown.Toggle variant="secondary" size="sm" id="item-dropdown">
                        &#x22EE;
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleDelete} disabled={deleting}>
                            {deleting ? "Deleting..." : "Delete item"}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            {deleteError && <div style={{ color: "red", marginTop: 8 }}>{deleteError}</div>}
            <div>
                <h3>{item.name}</h3>
                <NsnInfo
                    nsnInfo={nsn_info}
                    itemId={item.id}
                    onNsnAdded={fetchData}
                />
            </div>
        </div>
    );
};

export default ItemInfo;
